import TabsContent from './components/tabs-content'
import TabsList from './components/tabs-list'
import TabsRoot from './components/tabs-root'
import TabsTrigger from './components/tabs-trigger'

const TabsComponent = {
  Root: TabsRoot,
  List: TabsList,
  Trigger: TabsTrigger,
  Content: TabsContent
}

export default TabsComponent
